var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-modal',[_c('CardForm',{attrs:{"titulo":'Agregar admin'}},[_c('DataList',{ref:"datatable",staticClass:"mb-3",attrs:{"modal":"true","url":"admins","fields":_vm.fields,"toCuil":_vm.toCuil,"rowClick":_vm.agregar}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }